export const TOKEN_DURATION_HOUR = 2;